import { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react"
import { toast } from "react-toastify"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { ClipLoader } from 'react-spinners'
import { useInView } from 'react-intersection-observer'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { AnimatePresence, motion } from "motion/react"

import { Mixpanel } from "../../config/Mixpanel"
import constants, { courses, locationWiseUserDetails } from "../../utilities/constants"
import { resetQuestions, sendUserSkill } from "../../redux/mcqSlice"
import { setLandingPageDetails, resetDetails, setSource, selectLandingPageDetails, setUserDetails, setReferralId, setTestId, setUserSkillDetails, setShowAnimation, referralDetails, selectReferralDetails } from "../../redux/otherDetailsSlice"
import { resetAnswers } from "../../redux/answersSlice"
import { resetCourseContent } from "../../redux/personaliseCourseSyllabusSlice"
import { resetPostPaymentSlice, resetPrepaymentDetails } from "../../redux/postPaymentSlice"
import { fetchInfluencerDetail, resetInfluencerData } from "../../redux/influencersDataSlice"
import { getUserDetails, selectCityDetails, selectUniqueCertificateUsers, setAuthToken, setCity, setSecondTimeStamp, setShowNotReferralSection, setThirdTimeStamp, setTimeStamp, setUniqueCertificateUsers, setUserCertified, setUserEnrolled, setUserFromSkillId } from "../../redux/authenticationSlice"
import { resetCourseSyllabus } from "../../redux/newPostPaymentSlice"
import { resetInitialState } from "../../redux/multiSkillSelectionSlice"
import { resetResults } from "../../redux/searchSlice"
import { resetInitialStateOfPack } from "../../redux/largerComboPackSlice"
import { resetTimer } from "../../redux/timerSlice"
import { dayResetTimer } from "../../redux/dayTimerSlice"
import { resetAddOnDetails, setFindMoreClicked } from "../../redux/addOnSlice"
import { resetUnPaidUserDetails } from "../../redux/unPaidUserSlice"
import { getCertificateDetailsFromMongo, getCertificateDetailsFromXano, getReferralDetails, resetReferallIdData, selectCertificateDetailsData, selectReferralData } from "../../redux/referralDetails"
import { API_GET_LOCATION_WITHOUT_PERMISSION, API_XANO_CERTIFIED_BASE_URL } from "../../config/api_config"
import { Api_url } from "../../common/api_url"
import axios from "axios"

import useWindowSize from "../../hooks/useWindowSize"

import Logos from "../../components/Logos"

import CompanyIconAnimation from "./CompanyIconAnimation"
import AnimatedBottomSentence from "./AnimateBottomSentence"
import InfiniteScrollSentence from "./InfiniteScrollSentence"
import { DesktopTrendingPageLoader } from "../../components/LandingPageLoader"
import CarouselLoader from "./CarouselLoader"
import { selectNewSavedData } from "../../redux/newSavedDataSlice"
import { preloadCourseAndSkillSelectionPage, preloadOnboardingPage } from "../../App"
import { resetBadgeState } from "../../redux/badgeSlice"
import { resetScenarioDetails } from "../../redux/scenarioDetailsSlice"
import { resetPowerminuteDetails } from "../../redux/powerminuteSlice"

const DesktopCarousel = lazy(() => import("./DesktopCarousel"))
const MobileCarousel = lazy(() => import("./MobileCarousel"))
const TrendingSkills = lazy(() => import("./TrendingSkills"))
const HowItWorks = lazy(() => import("./HowItWorks"))
const PersonaliseCourseCard = lazy(() => import("./PersonaliseCourseCard"))
const RecommendedCourse = lazy(() => import("./RecommendedCourse"))
const DesktopHowItWorks = lazy(() => import("./DesktopHowItWorks"))
const MobileNotInterestedSection = lazy(() => import("./MobileNotInterestedSection"))
const DesktopOneMoreThing = lazy(() => import("./DesktopOneMoreThing"))
const DesktopRecommendedCourse = lazy(() => import("./DesktopRecommendedCourse"))
const DesktopNotInterestedSection = lazy(() => import("./DesktopNotInterestedSection"))
const DesktopTrendingSkills = lazy(() => import("./DesktopTrendingSkills"))

const imagesOne = [
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Mask%20group.png?updatedAt=1743837476049',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Mask%20group-1.png?updatedAt=1743837475842',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Mask%20group-2.png?updatedAt=1743837475819',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Mask%20group-3.png?updatedAt=1743837475955',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Mask%20group-4.png?updatedAt=1743837475793'
]

const imagesTwo = [
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/adobe.png?updatedAt=1743837299800',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Mask%20group.png?updatedAt=1743837219490',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Mask%20group-1.png?updatedAt=1743837219364',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Mask%20group-2.png?updatedAt=1743837219692',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Mask%20group-3.png?updatedAt=1743837219494'
]

export const userProfile = [
    {
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/idaWddwxka_1743842167100.jpeg?updatedAt=1743842187042',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/image.png?updatedAt=1744024275926',
        tag: <span>This certificate helped me land a <span className="font-semibold text-white">MNC job</span> at Baker Hughes <span className="font-semibold text-white">with a 150% hike.</span></span>,
        subject: 'Data Science',
        name: 'Shweta Singh',
        firstName: 'Shweta',
        place: 'Mumbai'
    },
    {
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/idIvolSN8d_1743842413540.jpeg?updatedAt=1743842443199',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/1735568060954.jpg?updatedAt=1743842381557',
        tag: <span>This certificate helped me land my <span className="font-semibold text-white">dream job at Phone Pe.</span></span>,
        subject: 'Tableau with SQL',
        name: 'Abhishek Zine',
        firstName: 'Abhishek',
        place: 'Aurangabad'
    },
    {
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/idpqoJMV_H_1743842575769.jpeg?updatedAt=1743842594719',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/1733074340143.jpg?updatedAt=1743842542116',
        tag: <span>This certificate helped me land a <span className="font-semibold text-white">42% Salary hike at Infosys.</span></span>,
        subject: 'Project Management',
        name: 'Saptarshi Das',
        firstName: 'Saptarshi',
        place: 'Bengaluru'
    },
]

export const mobileCarouselImages = [
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/main.webp?updatedAt=1744702991495',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Frame%20427320753%20(1).webp?updatedAt=1744702592949',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/abhi.webp?updatedAt=1744699957446',
    'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Saptarshi.webp?updatedAt=1744700127748'
]

const LandingPage = () => {

    const location = useLocation()

    const params = new URLSearchParams(location.search)
    const utm_source1 = params.get("utm_source")
    const utm_medium = params.get("utm_medium")
    const utm_campaign = params.get("utm_campaign")
    const source = params.get("source")
    const jwt_token = params.get("uuid")
    const referral_id = params.get("referral_id")
    const isReferral = params.get("isReferral")
    const test_id = params.get("test_id")
    const email = params.get("email")
    const skill_name_from_url = params.get("skill_name")
    const unique_certificate_id = params.get("unique_certificate_id")
    const refer = params.get("ref")

    const { skill_name, utm_source } = useParams()

    const referralData= useSelector(selectReferralDetails)
    const landingPageDetails = useSelector(selectLandingPageDetails)
    const referralDataFromId = useSelector(selectReferralData)
    const certificateDetails = useSelector(selectCertificateDetailsData)
    const cityDetails = useSelector(selectCityDetails)
    const newSavedData = useSelector(selectNewSavedData)
    const uniqueCertificateUsers = useSelector(selectUniqueCertificateUsers)
    
    const userSkillName = landingPageDetails?.skill_name
    const utmMedium = landingPageDetails?.utm_medium
    const utmSource = landingPageDetails?.utm_source
    const utmCampaign = landingPageDetails?.utm_campaign
    const referrerScore = certificateDetails?.quiz_score
    const firstTimeStamp = cityDetails?.timeStamp
    const city = cityDetails?.city
    const userEnrolled = cityDetails?.userEnrolled
    const secondTimeStamp = cityDetails?.secondTimeStamp
    const thirdTimeStamp = cityDetails?.thirdTimeStamp
    const usersCount = cityDetails?.usersCertified
    const userDetailsFromId = cityDetails?.userDetailsFromSkillId
    const showNotReferralSection = cityDetails?.showNotReferralSection
    const showLandingPageTrendingSkills = newSavedData?.showLandingPageTrendingSkills

    const referrerName = (referral_id ? referralDataFromId?.name : unique_certificate_id ? certificateDetails?.name : refer ? userDetailsFromId?.name : isReferral ? referralData?.FRIEND_NAME : '')?.split(' ')?.[0]

    const [ courseName, setCourseName ] = useState("")
    const [ skillName, setSkillName ] = useState("")
    const [ navigateToSkill, setNavigateToSkill ] = useState(false)
    const [ navigateToCourse, setNavigateToCourse ] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const [ recommendedCourses , setRecommendedCourses ] = useState([])
    const [ showTopRow, setShowTopRow ] = useState(true)
    const [ loadReferralData, setLoadReferralData ] = useState(false)
    const [ index, setIndex ] = useState(0)
    const [ topIndex, setTopIndex ] = useState(0)
    const [ trendingSkillClick, setTrendingSkillClick ] = useState('')
    const [ trendingSkillLoading, setTrendingSkillLoading ] = useState('')
    
    const { width, height } = useWindowSize()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const howItWorksRef = useRef(null)
    const howItWorksLargeScreenRef = useRef(null)
    const personaliseRef = useRef(null)
    const personaliseRefTwo = useRef(null)

    const fromReferral = referral_id || isReferral || unique_certificate_id || refer
    const isLargeScreen = width >= 1024

    const scrollToHowItWorks = useCallback(() => {
        if(isLargeScreen){
            howItWorksLargeScreenRef.current?.scrollIntoView({ behavior: 'smooth' })
        }else{
            howItWorksRef.current?.scrollIntoView({ behavior: 'smooth' })
        }
    }, [isLargeScreen])

    const handlePersonaliseScroll = useCallback(() => {
        Mixpanel.track(constants.Mixpanel.LANDING_PAGE_UNLOCK_FREE_COURSE_BANNER_CLICKED)
        if(isLargeScreen){
            personaliseRef.current?.scrollIntoView({ behavior: 'smooth' })
        }else{
            personaliseRefTwo.current?.scrollIntoView({ behavior: 'smooth' })
        }
    }, [isLargeScreen])

    const { ref, inView } = useInView({
        threshold: 0.5,
        rootMargin: '0px 0px -100px 0px'
    })

    useEffect(() => {
        preloadOnboardingPage()
        preloadCourseAndSkillSelectionPage()
    }, [])

    useEffect(() => {
        dispatch(resetBadgeState())
    }, [dispatch])

    useEffect(() => {
        const interval = setInterval(() => {
            setShowTopRow(prev => !prev)
        }, 4000)
        return () => clearInterval(interval)
    }, [])
    
    useEffect(() => {
        if (!fromReferral) {
            const timer = setTimeout(() => {
                dispatch(setShowNotReferralSection(true))
            }, 60000)
        
            return () => clearTimeout(timer)
        }
    }, [dispatch, fromReferral])

    useEffect(() => {
        if(referral_id){
            dispatch(getReferralDetails({ id: referral_id }))
            dispatch(setUserFromSkillId({}))
        }
    }, [dispatch, referral_id])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenData = await axios.get(API_XANO_CERTIFIED_BASE_URL + Api_url.GetWhatsAppToken, {
                    headers: {
                        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZXJ0aWZpZWRfdXNlcl9za2lsbF9pZCI6MTE4NTExMywibmFtZSI6IkthcnRoaWsgQSBNIiwicGhvbmVfbnVtYmVyIjoiKzkxOTQ0ODU3NTEzMSIsImVtYWlsIjoiZ2V0a2FyMTI4QGdtYWlsLmNvbSIsInBhc3N3b3JkIjoiZ2V0a2FyMTI4QGdtYWlsLmNvbSJ9.8zxD4X_9B-E2lLvvQEZ2tsMAhozVE4e2CMwgqrBoLtQ`
                    },
                    params: {
                        certified_user_skill_id: refer
                    }
                })
                const response = await axios.get(API_XANO_CERTIFIED_BASE_URL + Api_url.GetUserDetail, {
                    headers: {
                        Authorization: `Bearer ${tokenData?.data?.data}`
                    }
                })
                if(response.data?.status_code === 500){
                    return navigate('/')
                }
                dispatch(setUserFromSkillId(response.data))
                dispatch(resetReferallIdData())
            } catch (error) {
                console.log(error?.message)
            }
        }
        if(refer){
            fetchData(refer)
        }
    }, [dispatch, navigate, refer])

    useEffect(() => {

        const shouldFetch = !firstTimeStamp || Date.now() - firstTimeStamp > 24 * 60 * 60 * 1000
        
        if(!shouldFetch) return
        
        const randomDigitGenerate = () => {
            const min = 7000
            const max = 10000
            return Math.floor(Math.random() * (max - min + 1)) + min
        }
        dispatch(setUserCertified(randomDigitGenerate()))
        dispatch(setTimeStamp(Date.now()))
    }, [dispatch, firstTimeStamp])
    
    useEffect(() => {
        const shouldFetch = !thirdTimeStamp || Date.now() - thirdTimeStamp > 24 * 60 * 60 * 1000
        if(!shouldFetch) return
        dispatch(setUniqueCertificateUsers(Math.floor(Math.random()*(901 - 400)) + 400))
        dispatch(setThirdTimeStamp(Date.now()))
    }, [dispatch, thirdTimeStamp])
    
    useEffect(() => {

        const shouldFetch = !secondTimeStamp || Date.now() - secondTimeStamp > 24 * 60 * 60 * 1000

        if(!shouldFetch) return
        
        const fetchLocationAndData = async () => {
            try {
                const res = await axios.get(API_GET_LOCATION_WITHOUT_PERMISSION)
                const userCity = res.data.city
                
                const matchedCity = locationWiseUserDetails.find(c => c.city === userCity)
                
                if (matchedCity) {
                    const { minValue, maxValue } = matchedCity
                    const enrolled = Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue
        
                    dispatch(setCity(userCity))
                    dispatch(setUserEnrolled(enrolled))
                    dispatch(setSecondTimeStamp(Date.now()))
                } else {
                    const randomCity = locationWiseUserDetails[Math.floor(Math.random() * 17)]
                    const { city, minValue, maxValue } = randomCity
                    const enrolled = Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue
        
                    dispatch(setCity(city))
                    dispatch(setUserEnrolled(enrolled))
                    dispatch(setSecondTimeStamp(Date.now()))
                }
            } catch (error) {
                console.error('Failed to fetch location:', error)
            }
        }

        fetchLocationAndData()
    }, [dispatch, secondTimeStamp])

    const extractSkillRecommendations = (data) => {
        const recommendations = []
        Object.keys(data).forEach(key => {
            if (key.startsWith("SKILL_REC_")) {
                if(data[key].toLowerCase() !== userSkillName.toLowerCase()){
                    recommendations.push(data[key])
                }
            }
        })
        return recommendations
    }

    useEffect(() => {
        if(referralData){
            const extractedSkills = extractSkillRecommendations(referralData)
            setRecommendedCourses(extractedSkills)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [referralData])

    function capitalizeFirstLetter(sentence = "") {
        const words = sentence.split(" ")
        const capitalizedWords = words.map((word) => {
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1)
            }
            return word
        })
        const capitalizedSentence = capitalizedWords.join(" ")
        return capitalizedSentence
    }

    const fetchData = useCallback(async (token) => {
        try {
            const response = await dispatch(getUserDetails(token))
            const { name, email, phone_number } = response.payload
            dispatch(setUserDetails({ name, email, phone_number }))
        } catch (error) {
            console.log(error.message)
        }
    },[dispatch])

    useEffect(() => {
        if(isReferral){
            Mixpanel.track(constants.Mixpanel.REFERRAL_PAGE)
        }
        else{
            Mixpanel.track(constants.Mixpanel.LANDING_PAGE)
        }
        dispatch(setAuthToken(""))
        dispatch(resetInfluencerData())
        dispatch(resetQuestions())
        dispatch(resetDetails())
        dispatch(resetAnswers())
        dispatch(resetCourseContent())
        dispatch(resetPrepaymentDetails())
        dispatch(setShowAnimation(-1))
        dispatch(resetCourseSyllabus())
        dispatch(resetInitialState())
        dispatch(resetResults())
        dispatch(resetInitialStateOfPack())
        dispatch(resetPostPaymentSlice())
        dispatch(resetTimer())
        dispatch(dayResetTimer())
        dispatch(resetAddOnDetails())
        dispatch(resetUnPaidUserDetails())
        dispatch(resetScenarioDetails())
        dispatch(resetPowerminuteDetails())
        if (source === "academy") {
            dispatch(setSource(source))
            dispatch(fetchInfluencerDetail(utm_source1))
        }
        if (jwt_token) {
            dispatch(setAuthToken(jwt_token))
            fetchData(jwt_token)
        }
        if ((utm_source && !utm_source?.includes("=")) || (skill_name && !skill_name?.includes("="))){
            navigate("/error")
        }
        if (referral_id) {
            dispatch(setReferralId(referral_id))
        }
        if (test_id) {
            dispatch(setTestId(test_id))
        }
        let utmSource = utm_source?.split("=")
        let skill = skill_name?.split("=")

        if (!skill_name || !skill?.[1]) {
            dispatch(
                setLandingPageDetails({
                    skillName: "",
                    utmSource: refer ? refer : utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
                    courseName: "",
                    utmMedium: refer ? 'referral' : utm_medium || "",
                    utmCampaign: utm_campaign || "",
                })
            )
            setNavigateToCourse(true)
        } else if (courses?.filter((item) => item.course_slug === skill?.[1])[0]) {
            const courseDetail = courses?.filter(
                (item) => item.course_slug === skill?.[1]
            )[0]
            Mixpanel.people.set({
                courseName: courseDetail?.name,
            })
            dispatch(setLandingPageDetails({
                skillName: "",
                utmSource: refer ? refer : utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
                courseName: courseDetail?.name,
                utmMedium: refer ? 'referral' : utm_medium || "",
                utmCampaign: utm_campaign || "",
            }))
            setCourseName(courseDetail?.name)
            setNavigateToSkill(true)
        } else {
            Mixpanel.people.set({
                skillName: capitalizeFirstLetter(skill?.[1]),
            })
            dispatch(setLandingPageDetails({
                skillName: capitalizeFirstLetter(skill?.[1]),
                utmSource: refer ? refer : utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
                courseName: "",
                utmMedium: refer ? 'referral' : utm_medium || "",
                utmCampaign: utm_campaign || "",
            }))
            setSkillName(capitalizeFirstLetter(skill?.[1]))
        }
        if (skill_name_from_url) {
            setSkillName(skill_name_from_url)
            dispatch(setUserSkillDetails(skill_name_from_url))
            setNavigateToCourse(false)
        }

    }, [dispatch, jwt_token, navigate, skill_name, utm_source, utm_source1, source, utm_medium, fetchData, referral_id, test_id, skill_name_from_url, utm_campaign, isReferral, refer])

    const handleSubmit = async () => {
        if (loading){
            return
        }
        setLoading(true)
        try {
            if (navigateToCourse && !isReferral) {
                Mixpanel.track(constants.Mixpanel.LANDING_PAGE_BUTTON_CLICKED)
                navigate('/1/course-page')
            }
            else if (navigateToSkill && !isReferral){
                Mixpanel.track(constants.Mixpanel.LANDING_PAGE_BUTTON_CLICKED)
                navigate('/2/skill-page')
                
            }else {
                if(isReferral){
                  Mixpanel.track(constants.Mixpanel.REFERRAL_PAGE_BUTTON_CLICKED)
                }
                else{
                  Mixpanel.track(constants.Mixpanel.LANDING_PAGE_BUTTON_CLICKED)
                }
                await  dispatch(sendUserSkill({ subject_name: userSkillName, utm_source: utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign })).unwrap()
                navigate('/onboarding')
            }
        } catch (error) {
            toast.error('Oops, that request failed. Please try again!')
        }finally{
            setLoading(false)
        }
        
    }
   
    useEffect(()=>{
        const fetchData = async () => {
            setLoadReferralData(true)
            try {
                await dispatch(referralDetails({ email : email })).unwrap()
                dispatch(setUserFromSkillId({}))
                dispatch(resetReferallIdData())
            } catch (error) {
                toast.error('Something Went Wrong in Fetching Referral Data')
            }finally{
                setLoadReferralData(false)
            }
        }
        if( isReferral && email){
            fetchData()
        }
    },[dispatch, email, isReferral])

    useEffect(() => {
        if(unique_certificate_id){
            const uniqueCertificateArray = unique_certificate_id?.split('-')
            if(uniqueCertificateArray?.[1] === 'B'){
                dispatch(getCertificateDetailsFromMongo({ unique_certificate_id }))
            }else{
                dispatch(getCertificateDetailsFromXano({ unique_certificate_id }))
            }
            dispatch(setUserFromSkillId({}))
        }
    }, [dispatch, unique_certificate_id])
  
    const buttonBottomSentence = useMemo(() => {
        return ([
            <div className="flex justify-center items-center gap-1">
                <img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Frame%20427320740.png?updatedAt=1743851654816" width={46} height={22} alt="" />
                <p className="text-xs lg:text-sm text-[#D5EDFF] font-semibold leading-[130%]"><span className="text-[#83BEFF] font-medium">{usersCount} certified this week</span> in under 10 mins</p>
            </div>,
            <p className="text-center text-xs lg:text-sm text-[#D5EDFF]">
                <span className="text-[#83BEFF] font-bold">{userEnrolled}+ from </span> <img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Map%20pin.svg?updatedAt=1744351536662" width={15} height={15} className="image-inline" alt="" /> <span className="text-[#83BEFF] font-medium">{city} Scored &gt;60% this week.</span> <span className="font-medium">Check yours!</span>
            </p>
        ])
    }, [usersCount, userEnrolled, city])

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % buttonBottomSentence.length)
        }, width >= 1024 ? 8000 : 6000)
        return () => clearInterval(interval)
    }, [buttonBottomSentence, width])

    async function recommendedSkillHandler(item){
        if(loading){
            return
        }
        setLoading(true)
        setTrendingSkillClick(item)
        setTrendingSkillLoading(item)
        setTimeout(() => {
            setTrendingSkillClick('')
        }, 300)
        try {
            await  dispatch(sendUserSkill({ subject_name: item, utm_source: utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign })).unwrap()
            dispatch(setLandingPageDetails({
                skillName: item,
                utmSource: utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
                courseName: "",
                utmMedium: utm_medium || "",
                utmCampaign: utm_campaign || "",
            }))
            navigate('/onboarding')
        } catch (error) {
            toast.error('Something Went Wrong! Try Again!')
        }finally{
            setLoading(false)
            setTrendingSkillLoading('')
        }
    }

    const handleCoursePage = () => {
        navigate('/1/course-page')
    }

    const handleFindMore = () => {
        Mixpanel.track(constants.Mixpanel.LANDING_PAGE_FIND_MORE_BUTTON_CLICKED)
        dispatch(setFindMoreClicked(true))
        handleCoursePage()
    }

    const topSentences = useMemo(() => {
        return ([
            <p onClick={scrollToHowItWorks} className={`${width <= 360 || height < 720 ? 'text-xxs' : 'text-xs'} lg:text-xs text-[#D5EDFF] cursor-pointer lg:text-center`}><img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Thumbs%20up.png?updatedAt=1744354896900" className="image-inline -mt-[3px]" width={10} height={10} alt="" /> <span className="font-bold text-white">{referrerName}</span> got certified & recommends you should too</p>,
            <p className={`${width <= 360 || height < 720 ? 'text-xxs' : 'text-xs'} lg:text-xs text-[#D5EDFF] lg:text-center cursor-pointer`} onClick={handlePersonaliseScroll}><img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/image%20832.png?updatedAt=1744215263145" width={12} height={13} className="image-inline -mt-[3px]" alt="" /> <span className="text-white font-bold">Unlock a FREE Course in Any Topic</span> using {referrerName}’s link</p>
        ])
    }, [handlePersonaliseScroll, height, referrerName, scrollToHowItWorks, width])

    useEffect(() => {
        const interval = setInterval(() => {
            setTopIndex((prev) => (prev + 1) % topSentences.length)
        }, 6000)
        return () => clearInterval(interval)
    }, [topSentences])
    
    const calculatedHeight = (!fromReferral) ? (isLargeScreen ? (!showNotReferralSection ? `calc(100dvh - 100px)` : `calc(100dvh - 60px)`) : (skillName && !showLandingPageTrendingSkills )? `calc(100dvh - 220px)` : `calc(100dvh - 186px)`) : !isLargeScreen ?  `calc(100dvh - 220px)` : undefined

    return (
        <div className='w-full h-[100dvh] bg-custom-bg overflow-y-auto overflow-x-hidden flex flex-col relative cursor-default' >
            {fromReferral && <div className={`w-full mx-auto ${width <= 360 || height < 720 ? 'py-3' : 'py-3.5'} lg:py-3.5 bg-[#4285F4] lg:bg-[#3451B9]/40 ${!isReferral && !unique_certificate_id && 'px-4'} text-xs`}>
                {isReferral ? 
                    <InfiniteScrollSentence sentence={<p onClick={scrollToHowItWorks} className={`${width <= 360 || height < 720 ? 'text-xxs' : 'text-xs'} cursor-pointer lg:text-xs text-[#D5EDFF] lg:text-center`}><img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Thumbs%20up.png?updatedAt=1744354896900" className="image-inline -mt-[3px]" width={10} height={10} alt="" /> <span className="font-bold text-white">{referrerName}</span> got certified & recommends you should too</p>} /> 
                : (referrerScore && skillName) ? 
                    <InfiniteScrollSentence sentence={<p onClick={scrollToHowItWorks} className={`${width <= 360 || height < 720 ? 'text-xxs' : 'text-xs'} lg:text-xs text-[#D5EDFF] cursor-pointer lg:text-center`}>🎯 <span className="font-bold text-white">{referrerName} scored {referrerScore}%</span> Check your score!</p>} />
                : (unique_certificate_id && referrerScore >= 0 && !skillName) ? 
                    <InfiniteScrollSentence sentence={<p onClick={scrollToHowItWorks} className={`${width <= 360 || height < 720 ? 'text-xxs' : 'text-xs'} cursor-pointer lg:text-xs text-[#D5EDFF] lg:text-center`}><img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Thumbs%20up.png?updatedAt=1744354896900" className="image-inline -mt-[3px]" width={10} height={10} alt="" /> {referrerScore > 60 ? <span><span className="font-bold text-white">{referrerName}</span> got certified & <span className="font-bold text-white">scored {referrerScore}% </span>🚀</span> : <span><span className="font-bold text-white">{referrerName}</span> got certified & scored better than <span className="font-bold text-white">{uniqueCertificateUsers} people</span>🚀</span>}</p>}  />
                : unique_certificate_id ? 
                    <InfiniteScrollSentence sentence={<p onClick={scrollToHowItWorks} className={`${width <= 360 || height < 720 ? 'text-xxs' : 'text-xs'} cursor-pointer lg:text-xs text-[#D5EDFF] lg:text-center`}><img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Thumbs%20up.png?updatedAt=1744354896900" className="image-inline -mt-[3px]" width={10} height={10} alt="" /> <span className="font-bold text-white">{referrerName}</span> got certified & recommends you should too</p>} /> 
                : topIndex === 0 ? 
                    <AnimatedBottomSentence index={topIndex} sentence={topSentences[topIndex]} top={true}/> 
                : topIndex === 1 ? 
                    <AnimatedBottomSentence index={topIndex} sentence={topSentences[topIndex]} top={true}/> : null}
            </div>}
            <div className={`flex-1 w-full max-w-6xl mx-auto text-white p-4 ${showNotReferralSection || fromReferral ? 'lg:pb-20' : 'lg:pb-4'} flex flex-col`}>
                <div className='mb-6'>
                    <Logos margin={'mx-auto'}/>
                </div>
                <div className={`flex-1 flex flex-col`} style={calculatedHeight ? { minHeight: calculatedHeight } : {}}>
                    <div className={`flex-1 -mt-4 ${fromReferral && 'lg:mt-10'} flex flex-col lg:flex-row lg:gap-16 justify-center items-center`}>
                        <div className={`lg:flex-1 lg:w-full lg:max-w-[540px] ${skillName?.length > 36 ? 'lg:h-[450px]' : 'lg:h-[390px]'} lg:flex lg:flex-col lg:pb-3`}>
                            <div className="lg:flex-1">
                                <div className="md:w-4/5 mx-auto lg:w-full text-center lg:text-left">
                                    <h1 className={`${(width <= 360 || (height < 720 && fromReferral)) ? (skillName?.length >= 40 ? 'text-base' : 'text-lg') :  (skillName?.length >= 40 ? 'text-xl' : 'text-[26px]')} lg:text-[40px] font-semibold leading-[130%] text-[#D5EDFF]`}>Unlock Your <span className={`text-span_color ${skillName?.length >= 30 && 'hyphens-auto break-words'}`}>{courseName ? courseName : skillName ? skillName : ""} Certificate</span> <span className="gradient-text-2">Recognised by 1100+ Top Companies</span></h1>
                                </div>
                                <CompanyIconAnimation
                                    showTopRow={showTopRow}
                                    imagesOne={imagesOne}
                                    imagesTwo={imagesTwo}
                                />
                            </div>
                            <div className="hidden lg:block">
                                <div className={`px-4 py-3 rounded-xl bg-secondary-text text-lg font-bold text-[#121212] text-center ${!fromReferral && 'btn--glow'} cursor-pointer`} onClick={handleSubmit}>
                                    {loading ? <ClipLoader size={24} /> : <>Get Certified Now!<FontAwesomeIcon icon={faArrowRight} className="ml-3 arrow-move" /></>}
                                </div>
                                {fromReferral ? <div className="mt-2 flex justify-center items-center gap-1">
                                    <img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Frame%20427320740.png?updatedAt=1743851654816" width={46} height={22} alt="" />
                                    <p className="text-sm text-[#D5EDFF] font-semibold leading-[130%]"><span className="text-[#83BEFF] font-medium">{usersCount} certified this week</span> in under 10 mins</p>
                                </div> : <AnimatePresence mode="wait">
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 1 }}
                                        className="h-7 pt-2"
                                    >
                                        {buttonBottomSentence[index]}
                                    </motion.div>
                                </AnimatePresence>}
                            </div>
                        </div>
                        {width >= 640 && <Suspense fallback={<CarouselLoader />}>
                            <DesktopCarousel
                                inView={inView}
                                fromReferral={fromReferral}
                                scrollToHowItWorks={scrollToHowItWorks}
                            />
                        </Suspense>}
                        {width < 640 && <Suspense fallback={<CarouselLoader />}>
                            <MobileCarousel
                                inView={inView}
                                fromReferral={fromReferral}
                                scrollToHowItWorks={scrollToHowItWorks}
                            />
                        </Suspense>}
                    </div>
                </div>
                {!fromReferral && showNotReferralSection ? (skillName && !showLandingPageTrendingSkills ? <Suspense fallback={<DesktopTrendingPageLoader />}><MobileNotInterestedSection
                    skillName={skillName}
                    handleFindMore={handleFindMore}
                /></Suspense> : <Suspense fallback={<DesktopTrendingPageLoader />}><TrendingSkills 
                    recommendedSkillHandler={recommendedSkillHandler} 
                    trendingSkillLoading={trendingSkillLoading} 
                    trendingSkillClick={trendingSkillClick} 
                /></Suspense>) : (referral_id || refer) ? <div className="lg:hidden">
                    <div className="mt-10">
                        <Suspense fallback={<DesktopTrendingPageLoader />}><HowItWorks inViewRef={ref} ref={howItWorksRef} /></Suspense>
                    </div>
                    <div ref={personaliseRefTwo} className="">
                    <Suspense fallback={<DesktopTrendingPageLoader />}><PersonaliseCourseCard referrerName={referrerName} /></Suspense>
                    </div>
                </div> : ((isReferral || unique_certificate_id) && !loadReferralData) ? <div className="lg:hidden ">
                    {recommendedCourses?.length > 0 && <div className="mt-10 -ml-4 bg-[#0D2436] w-[calc(100%+32px)] pt-4 pb-5">
                        <p className="text-center font-semibold text-[#D5EDFF]">Recommended Certifications for your Profile</p>
                        <Suspense fallback={<DesktopTrendingPageLoader />}><RecommendedCourse 
                            recommendedCourses={recommendedCourses} 
                            recommendedSkillHandler={recommendedSkillHandler} 
                            trendingSkillLoading={trendingSkillLoading} 
                            trendingSkillClick={trendingSkillClick} 
                        /></Suspense>
                        <div className='mt-4 mx-auto w-fit px-4 flex gap-1 py-2 bg-[#406AFF]/40 border border-[#406AFF]/40 items-center rounded-lg text-xs font-medium bg-black-gradient hover:bg-black-gradient-hover'
                            onClick={() => {
                                Mixpanel.track(constants.Mixpanel.LANDING_PAGE_LI_HACK_FIND_MORE_CLICKED)
                                handleCoursePage()
                            }}
                        >
                            <p className='text-[#D5EDFF]'>Explore 1370+ Certifications</p>
                        </div>
                    </div>}
                    {unique_certificate_id && !skillName && <Suspense fallback={<DesktopTrendingPageLoader />}>
                        <TrendingSkills 
                            recommendedSkillHandler={recommendedSkillHandler} 
                            trendingSkillLoading={trendingSkillLoading} 
                            trendingSkillClick={trendingSkillClick} 
                        />
                    </Suspense>}
                    <div className={`${(isReferral || (unique_certificate_id && !skillName)) ? 'mt-10' : ''}`}>
                        <Suspense fallback={<DesktopTrendingPageLoader />}><HowItWorks inViewRef={ref} ref={howItWorksRef} /></Suspense>
                    </div>
                    {!unique_certificate_id ? <div 
                        className="p-[1px] rounded-lg"
                        style={{
                            backgroundImage: 'linear-gradient(to bottom, #83BEFF 0%, #4F7299 100%)'
                        }}
                    >
                        <div className="rounded-lg bg-[#114065] py-4 px-2 text-[#D5EDFF] text-sm text-center leading-[140%]">
                            {referralData?.INDUSTRY} Professionals certified with us earn <span className="font-bold text-[#83BEFF]">25% more than industry average</span>
                        </div>
                    </div> : !isReferral && skillName ? <Suspense fallback={<DesktopTrendingPageLoader />}><MobileNotInterestedSection
                        skillName={skillName}
                        handleFindMore={handleFindMore}
                        fromUniqueCertificate={true}
                    /></Suspense> : null}
                </div> : null}
                <div className="hidden lg:block">
                    {!fromReferral && showNotReferralSection ? (skillName ? <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopNotInterestedSection skillName={skillName} handleFindMore={handleFindMore} /></Suspense> : <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopTrendingSkills trendingSkillClick={trendingSkillClick} trendingSkillLoading={trendingSkillLoading} recommendedSkillHandler={recommendedSkillHandler} handleCoursePage={handleCoursePage} /></Suspense>) : ((referral_id || refer) ? <div className="flex flex-col gap-6 mt-[96px]">
                        <div ref={howItWorksLargeScreenRef}>
                            <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopHowItWorks /></Suspense>
                        </div>
                        <div ref={personaliseRef} className="">
                            <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopOneMoreThing referrerName={referrerName} /></Suspense>
                        </div>
                    </div> : (isReferral || unique_certificate_id) ? <div className="flex flex-col gap-6 mt-[96px]">
                        {recommendedCourses?.length > 0 && <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopRecommendedCourse
                            recommendedCourses={recommendedCourses} trendingSkillClick={trendingSkillClick} recommendedSkillHandler={recommendedSkillHandler} trendingSkillLoading={trendingSkillLoading} handleCoursePage={handleCoursePage}
                        /></Suspense>}
                        {unique_certificate_id && !skillName && <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopTrendingSkills trendingSkillClick={trendingSkillClick} trendingSkillLoading={trendingSkillLoading} recommendedSkillHandler={recommendedSkillHandler} handleCoursePage={handleCoursePage} /></Suspense>}
                        <div ref={howItWorksLargeScreenRef}>
                            <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopHowItWorks /></Suspense>
                        </div>
                        {!unique_certificate_id ? <div className="rounded-2xl bg-[#114065] py-6 px-2 text-[#D5EDFF] text-center leading-[140%]">
                            {referralData?.INDUSTRY} Professionals certified with us earn <span className="font-bold text-[#83BEFF]">25% more than industry average</span>
                        </div> : !isReferral && skillName ? <Suspense fallback={<DesktopTrendingPageLoader />}><DesktopNotInterestedSection skillName={skillName} handleFindMore={handleFindMore} fromUniqueCertificateId={true} /></Suspense> : null}
                    </div> : null)}
                </div>
                <div className={`lg:hidden ${!fromReferral ? (showNotReferralSection ? 'h-[200px]' : 'h-[86px]') : !unique_certificate_id  ? 'h-[110px]' : (unique_certificate_id && skillName) ? 'h-[110px]' : 'h-[76px]'} w-full`} />
            </div>
            <div className="z-20 fixed lg:hidden w-full bottom-0 bg-[#013A66] p-3">
                <div className={`rounded-xl text-center bg-secondary-text px-4 ${(width <= 360 || height < 720) ? 'text-[15px] py-2.5' : 'text-lg py-3'} font-bold text-[#121212] ${!fromReferral && 'btn--glow'} flex items-center justify-center`} onClick={handleSubmit}>
                    {loading ? <ClipLoader size={24} /> : <>Get Certified Now!<FontAwesomeIcon icon={faArrowRight} className="ml-3 arrow-move" /></>}
                </div>
                {fromReferral ? <div className="mt-3 flex justify-center items-center gap-1">
                    <img src="https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/Landing%20Page%20LATEST%2029/Frame%20427320740.png?updatedAt=1743851654816" width={46} height={22} alt="" />
                    <p className="text-xs text-[#D5EDFF] font-semibold leading-[130%]"><span className="text-[#83BEFF] font-medium">{usersCount} certified this week</span> in under 10 mins</p>
                </div> : index === 0 ? <AnimatedBottomSentence sentence={buttonBottomSentence[index]} index={index} /> : index === 1 ? <AnimatedBottomSentence sentence={buttonBottomSentence[index]} index={index} /> : null}
            </div>
        </div>
    )}

export default LandingPage
